module.exports = __webpack_public_path__ + "static/media/cedg.155b1ab9.png";